import { DefaultService } from '@/services/DefaultService';

export default class SubGrupoProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(cliente) {
        return this._http.post(`${this._env}/promotor/produto/subgrupo`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/produto/subgrupo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findERP(idERP) {
		return this._http.get(`${this._env}/promotor/produto/subgrupo/codigo/${idERP}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    delete(id) {
        return this._http.delete(`${this._env}/promotor/produto/subgrupo/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    changeSituacao(subgrupo) {
        return this._http.post(`${this._env}/product/subgrupoproduto/updatesituacao`, subgrupo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }


    findAllCombo(page, limit, sort, grupoid, situacao = 2, ...param) {
        return this._http.get(encodeURI(`${this._env}/product/getcombo/subgroup.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}&grupoid=${grupoid}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page, limit, sort, grupoid, situacao = 2, ...param) {
        return this._http.get(encodeURI(`${this._env}/promotor/produto/subgrupo.json?page=${page}&limit=${limit}&column=${sort.column}&order=${sort.order}&grupoid=${grupoid}&situacao=${situacao}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByGroup(page, limit, idgrupo) {
        return this._http.get(`${this._env}/promotor/produto/subgrupo/group.json?page=${page}&limit=${limit}&idgroup=${idgrupo}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}